import {AttributeFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterFlyoutGeneric} from '@aboutyou/ui-components';
import React from 'react';
import {useAttributeFilterSection} from '../../shared/useAttributeFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: AttributeFilterSection;
  hide: VoidFunction;
  isOpen: boolean;
  open: VoidFunction;
  submit: VoidFunction;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
  }) => void;
  isSingleSelect?: boolean;
  enableFlyoutFilter: boolean;
};

export const FilterSectionAttribute: React.FC<Props> = ({
  activeFilters,
  data,
  hide,
  isOpen,
  open,
  submit,
  setFilter,
  isSingleSelect = false,
  enableFlyoutFilter,
}) => {
  const {
    activeSlugFilters,
    slug,
    normalizedValues,
    label,
    headline,
    description,
    handleAttributeClick,
  } = useAttributeFilterSection({
    data,
    activeFilters,
    setFilter,
    isSingleSelect,
  });

  return (
    <FilterFlyoutGeneric
      activeItemIds={activeSlugFilters}
      dataTestId={`filterFlyoutSection_${slug}`}
      hide={hide}
      submit={submit}
      isOpen={isOpen}
      items={normalizedValues}
      key={`filter-flyout-attribute-${slug}`}
      label={label}
      headline={headline}
      description={description}
      onAttributeClick={handleAttributeClick}
      open={open}
      isSingleSelect={isSingleSelect}
      shouldDisplaySearchField={slug === 'productSeries'}
      enableFlyoutFilter={enableFlyoutFilter}
    />
  );
};
